import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['field', 'output'];

  static classes = ['over'];

  static values = {
    limit: Number,
  };

  connect() {
    this.change();
  }

  change() {
    const length = this.fieldTarget.value?.trim()?.length || 0;

    if (length > this.limitValue) {
      this.outputTarget.textContent = `${length - this.limitValue}자를 초과했습니다`;
      this.outputTarget.classList.add(this.overClass);
    } else {
      this.outputTarget.textContent = `${length} / ${this.limitValue}`;
      this.outputTarget.classList.remove(this.overClass);
    }
  }
}
